import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { Badge, Chip, Grid, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { getChanelStatusData, getWidgetConfig } from '../../../services/api-service';
import { filterTypes, WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import OZTable from '../../OZTable/OZTable';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import '../ChanelStatusDigital/ChannelStatus.css';
import { checkDataAccessFilters, determineFilterType, getUpdatedFilterType, secondsToMinSec } from '../../../utils/util';
import useChartResize from '../../../hooks/useChartResize';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import DurationSelector from '../../DurationSelector/DurationSelector';
import useRealTimeDuration from '../../../hooks/useRealTimeDuration';


export default function ChannelStatus(props: any) {
	const { useState, useRef } = React;
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [callType, setCallType] = React.useState('all');
	const downloadContent = useRef<null | any>(null);
	const [callStatus, setCallStatus] = useState<any>({});
	const [responseLength, setresponseLength] = useState<Number>(0);
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columnData, setColumnData] = useState<Array<any>>([]);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || '1');
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [toggleType, setToggleType] = React.useState('Agent');// changes done 
	const { chartContainerRef, chartDimensions } = useChartResize();
	const [allowedFilters, setAllowedFilters] = useState<string[]>(['Campaign', 'Skill', 'Group', 'CampaignType']);
	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const [duration, setDuration] = useState<any>();
	const [durationLabel, setDurationLabel] = useState<string>('Today');
	const { realtime, handleClickRealTime, getDuration } = useRealTimeDuration({ duration });

	const intervalRef = useRef<any>(null);
	const isWidgetDataLoadingRef = useRef<boolean>(false);

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setCallType(newValue);
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const handleDownload = (type: string) => {
		console.log(type);
	};

	const handleFilterDelete = (id: Number) => {
		const newFilter = callStatusFilter.filter((item: any) => item.id !== id);
		setCallStatusFilter(newFilter);
		props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId);
	};

	const clearFilter = () => {
		console.info('Clear all filter.');
		setCallStatusFilter([]);
		props?.handleFilterChange?.([], filterSection, props?.widgetId);
	};

	function handleDuration(type: string = '', timeObj: any) {
		if (type) {
			setDurationLabel(type);
			setDuration(timeObj);
		}
	}

	const [callStatusFilter, setCallStatusFilter] = useState<any>(props?.selectedFilters?.filters || []);

	const filterItems = callStatusFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	const getChannelStatus = async (filters = '0', duration: any) => {
		if (isWidgetDataLoadingRef.current || !duration) {
			console.log('Widget data fetch already in progress, skipping this cycle getChannelStatus');
			return;
		};
		isWidgetDataLoadingRef.current = true;
		try {
			let adjustedDuration = getDuration();
			const data: any = await getChanelStatusData({
				filters,
				type: getUpdatedFilterType(filterType, 'number'),
				callType,
				dateTypeId: '0',
				...adjustedDuration
			});
			console.log(filterTypes);
			const newFilterType = filterType === '11' || filterType === 11 ? '1' : filterType;
			const filterKey = filterTypes.find((item: any) => item.id === +newFilterType) ?? filterTypes[0];
			console.log(filterKey);
			const filterValueKey = `${filterKey.value}Name`;
			console.log(filterValueKey);
			const totalValueData = data.find((item: any) => item[filterValueKey] === '0');
			if (callStatusFilter.length <= 2) {
				const historicData = await getChanelStatusData({ filters, type: getUpdatedFilterType(filterType, 'number'), callType, dateTypeId: '1', ...adjustedDuration });
				const totalHistoricValueData = historicData.find((item: any) => item[filterValueKey] === '0');
				if (totalValueData) {
					// totalValueData.averageHandlingTimeTicker = +totalHistoricValueData?.AVGSessiontime
					// 	? +(((+totalValueData.AVGSessiontime - +totalHistoricValueData.AVGSessiontime) / +totalHistoricValueData.AVGSessiontime) * 100).toFixed(2)
					// 	: 0;
					totalValueData.averageAnswerTimeTicker = +totalHistoricValueData?.AVGSessiontime
						? +(((+totalValueData.AVGSessiontime - +totalHistoricValueData.AVGSessiontime) / +totalHistoricValueData.AVGSessiontime) * 100).toFixed(2)
						: 0;
					// const activeCalls = await getActiveCalls();
					// totalValueData.activeCalls = activeCalls.ActiveCallsInIVR;
				}

				console.log('totalVaueData-----> ', data[0]);

				setCallStatus(totalValueData ?? {});
			} else {
				const columns = [
					{ name: filterKey.label, key: filterValueKey },
					{ name: 'AHT', key: 'AverageHandlingTime', subTitle: totalValueData.AverageHandlingTime },
					{ name: 'ATT', key: 'AverageTalkTime', subTitle: totalValueData.AverageTalkTime },
					{ name: 'AWT', key: 'AverageWrapupTime', subTitle: totalValueData.AverageWrapupTime },
					{ name: 'Avg. Hold Time', key: 'AverageHoldTime', subTitle: totalValueData.AverageHoldTime },
					{ name: 'Avg. Answer Time', key: 'AverageAnswerTime', subTitle: totalValueData.AverageAnswerTime },
					{ name: 'Active Calls', key: 'TotalCalls', subTitle: totalValueData.TotalCalls },
					{ name: 'Total Answered', key: 'AnsweredCalls', subTitle: totalValueData.AnsweredCalls },
					{ name: 'Total Abandoned', key: 'UnansweredCalls', subTitle: totalValueData.UnansweredCalls }
				];
				const actualData = data.filter((item: any) => item[filterValueKey] !== '0');
				setRowData(actualData);
				setColumnData(columns);
			}
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		}
		catch (error) {
			console.error('Error fetching channel status:', error);
		} finally {
			isWidgetDataLoadingRef.current = false;
		}
	};

	const handleFilterExistingData = (filteredData: any) => {
		setCallStatusFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId);
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection }: any) => {
		setCallStatusFilter(selectedFilters);
		setFilterType(newFilterType);
		setFilterSection(newfilterSection);
		props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId);
		toggleDrawer(false);
	};

	const handleToggleType = (event: React.SyntheticEvent, newValue: string) => { //changes done 
		setToggleType(newValue);
	};

	React.useEffect(() => {
		const fetchWidgetConfig = async () => {
			try {
				if (checkDataAccessFilters()) {
					let widgetConfig = await getWidgetConfig('132', 'widget');
					if (widgetConfig) {
						if (typeof widgetConfig === 'string') {
							widgetConfig = JSON.parse(widgetConfig);
						}
						// Check the condition and set the appropriate filters
						const filters = widgetConfig.data && checkDataAccessFilters()
							? widgetConfig.data
							: widgetConfig.config;

						if (filters) {
							const filtersArray = filters.split(',');
							setAllowedFilters(filtersArray);
							const determinedFilterType = determineFilterType(filtersArray);
							if (determinedFilterType !== undefined) {
								setFilterType(determinedFilterType);
							}
						}
					}
				}
			} catch (error) {
				console.error('Error fetching widget config:', error);
			}
		};
		fetchWidgetConfig();
	}, []);


	React.useEffect(() => {
		const filterIds = (callStatusFilter.length && !(responseLength === callStatusFilter.length)) ? callStatusFilter.map((item: any) => item.id).join(',') : '0';
		// const filterIds = callStatusFilter.length ? callStatusFilter.map((item: any) => item.id).join(',') : '0';
		getChannelStatus(filterIds, duration);
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}
		if (realtime) {
			intervalRef.current = setInterval(() => getChannelStatus(filterIds, duration), WIDGET_REFRESH_INTERVAL.CALL_STATUS);
		}
		return () => {
			clearInterval(intervalRef.current);
		};
	}, [callStatusFilter, callType, duration, realtime]);

	return (
		<Card className="customCard">
			<div className="card-header border-none">
				<div className="card-title">
					Channel Status<span className="card-sub-header">(Digital)</span>
					<div className="card-title-badge">Live</div>
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<ToggleButtonGroup value={toggleType} onChange={handleToggleType} color="primary" exclusive aria-label="bound">
						<ToggleButton value="Agent" style={{ width: '70px', padding: '5px' }} aria-label="Agent">
							<span>Agent</span>
						</ToggleButton>
						{/* <ToggleButton value="bot" style={{width: '73px', padding: '5px'}} aria-label="bot">
							<span>Bot</span>
						</ToggleButton> */}
					</ToggleButtonGroup>
					<DurationSelector
						duration={durationLabel}
						handleDuration={handleDuration}
						enableTodayDuration={true}
						showRealTimeToggle={true}
						realtime={realtime}
						handleClickRealTime={handleClickRealTime}
					/>
					<WidgetDownload element={downloadContent} handleDownload={handleDownload} name={'Channel Status (Digital)'}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={callStatusFilter.length} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
				</div>
			</div>
			{/* <FilterDrawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} existingSelectedFilters={callStatusFilter} additionalApiParams={{ campaignType: 'Chat' }} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} /> */}
			<FilterDrawer disableCampaignGroupSelection={true} isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} allowedFilters={allowedFilters} applyFilters={handleApplyFilters} existingSelectedFilters={callStatusFilter} additionalApiParams={{ campaignType: 'Chat' }} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} />

			<Box ref={downloadContent} sx={{ width: '100%', typography: 'body1', height: '100%' }}>
				<TabContext value={callType}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<TabList onChange={handleChange} className="customTabs">
							<Tab label="All" value="all" />
							<Tab label="Whatsapp" value="whatsapp" />
							<Tab label="Web Chat" value="web" />
							<Tab label="SMS" value="sms" />
							{/* <Tab label="Preview" value="preview" />
							<Tab label="Progressive" value="progressive" /> */}
						</TabList>
					</Box>
					<div className="customTabPanel" style={{ height: "calc(100% - 82px)", backgroundColor: "#FFFFFF" }} ref={chartContainerRef}>
						<Grid container spacing={2} height={"100%"} alignItems={"center"}>
							{callStatusFilter.length > 0 && (
								<Grid item xs={12}>
									<div className="filter-outer">
										<div className="filter-container">
											<Stack direction="row" spacing={1}>
												{filterItems}
											</Stack>
										</div>
										<div className="filter-remove" onClick={clearFilter}>
											Remove
										</div>
									</div>
								</Grid>
							)}
							{callStatusFilter.length > 2 ? (
								<OZTable rows={rowData} columns={columnData} noMaxHeight={true} height={Math.floor(chartDimensions.height - 36)} />
							) : (
								<>
									<Grid item xs={12} display={"flex"} height={"40%"} minHeight={"125px"} bgcolor={"FFFFFF"} style={{ border: "1px solid #e6e5e6", borderRadius: "12px" }} alignItems={"center"} m={1} ml={3} px={2} py={1} justifyContent={"space-between"}>
										<Grid item >
											<div className="widget-values-container" style={{ height: "100%", paddingLeft: "0px" }} >
												<div className="widget-caption">Total Session Time</div>
												<div className="widget-values">
													<div className="widget-value">{secondsToMinSec(callStatus.TotalSessionTime) || '-'}</div>
													<div className={`widget-value-update ${callStatus.averageHandlingTimeTicker < 0 ? 'red' : ''}`}>
														{callStatus.averageHandlingTimeTicker < 0 ? (
															<img src={`${process.env.PUBLIC_URL}/icons/down-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
														) : (
															<img src={`${process.env.PUBLIC_URL}/icons/up-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
														)}{' '}
														{`${callStatus.averageHandlingTimeTicker || 0}%`}
													</div>
												</div>
											</div>
										</Grid>
										<Grid item >
											<div className="widget-values-container widget-values-sm" style={{ height: "100%" }}>
												<div className="widget-caption">Average First Response Time</div>
												<div className="widget-values">
													<div className="widget-value">{secondsToMinSec(callStatus.AVGFirstResponseTime) || '-'}</div>
												</div>
											</div>
											{/* <Grid item xs={6}>
															<div className="widget-values-container widget-values-sm">
																<div className="widget-caption">Avg. Hold Time</div>
																<div className="widget-values">
																	<div className="widget-value">{secondsToMinSec(callStatus.AverageHoldTime) || '-'}</div>
																</div>
															</div>
														</Grid> */}
										</Grid>
										<Grid item >
											<div className="widget-values-container widget-values-sm" style={{ height: "100%" }}>
												<div className="widget-caption">Average Response Time</div>
												<div className="widget-values">
													<div className="widget-value">{secondsToMinSec(callStatus.AVGResponseTime) || '-'}</div>
												</div>
											</div>
										</Grid>
									</Grid>
									<Grid container ml={3} mr={1} gap={1} display={"flex"} justifyContent={"space-between"}>
										<Grid item xs={4.5} display={"flex"} height={"40%"} minHeight={"125px"} bgcolor={"FFFFFF"} sx={{ border: "1px solid #e6e5e6", borderRadius: "12px", padding: "0px 0px !important" }} alignItems={"center"} justifyContent={"center"}>
											<div className="widget-values-container widget-values-sm" style={{ paddingLeft: "0px" }}>
												<div className="widget-caption">Average Session Time</div>
												<div className="widget-values">
													<div className="widget-value widget-value-md">{secondsToMinSec(callStatus.AVGSessiontime) || '-'}</div>
													<div className={`widget-value-update ${callStatus.averageAnswerTimeTicker < 0 ? 'red' : ''}`}>
														{callStatus.averageAnswerTimeTicker < 0 ? (
															<img src={`${process.env.PUBLIC_URL}/icons/down-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
														) : (
															<img src={`${process.env.PUBLIC_URL}/icons/up-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
														)}{' '}
														{`${callStatus.averageAnswerTimeTicker || 0}%`}
													</div>
												</div>
											</div>
										</Grid>
										<Grid item xs={6.5} display={"flex"} height={"40%"} minHeight={"125px"} bgcolor={"FFFFFF"} sx={{ border: "1px solid #e6e5e6", borderRadius: "12px", padding: "0px 0px !important" }} alignItems={"center"} justifyContent={"center"}>
											<Grid item xs={6}>
												<div className="widget-values-container widget-values-sm">
													<div className="widget-caption">Total Conversations</div>
													<div className="widget-values">
														<div className="widget-value">{callStatus.TotalConversations || '-'}</div>
													</div>
												</div>
											</Grid>
											<Grid item xs={6}>
												<div className="widget-values-container widget-values-inline">
													<div className="widget-values-row">
														<div className="widget-caption">Total Connected</div>
														<div className="widget-value">{callStatus.TotalConnectedConversations || '-'}</div>
													</div>
													<div className="widget-values-row">
														<div className="widget-caption">Total Abandoned</div>
														<div className="widget-value">{callStatus.TotalabandonedConversations || '-'}</div>
													</div>
													{/* <div className="widget-values-row">
															<div className="widget-caption">Total Queued</div>
															<div className="widget-value">{callStatus.activeCalls || '0'}</div>
														</div> */}
												</div>
											</Grid>
										</Grid>
									</Grid>
								</>
							)}
						</Grid>
					</div>
				</TabContext>
			</Box>
		</Card>
	);
}
